exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-eb60e804]{resize:none;overflow:hidden;transition:none!important}", ""]);

// exports
